import type { Hco } from '@/core/graphql/generated/types';
import { formatAddress } from '@/utils/formatters/formatAddress';

export const getPrimaryAddressLocation = (hco: Hco): string => {
	if (!hco.addresses?.length) return '';
	const addr = hco.addresses.find(a => a.primaryCda_V) || hco.addresses[0];

	return formatAddress(addr) ?? '';
};
